import React from "react";

const LogoMarquee = ({
    speed = 48,     // mayor = más sutil/lento
    gapRem = 3,     // separación entre logos (rem)
  }) => {
    // Ajustes finos por marca (por si alguna es demasiado ancha/alta visualmente)
    // Puedes quitar/ajustar estas entradas si no las necesitas.
    const brandAdjust = {
      "Sushiexpress1.webp": "scale-90",
      "Elcosto.webp": "scale-90",
      "Grupotova.webp": "scale-90",
    };
  
    const logos = [
      // === 9 nuevos primero ===
      { src: "https://img.invupos.com/webinvu/LogoMarquee/Yogen_Fruz_Logo.svg_rbdk1o.png", alt: "Yogen Fruz" },
      { src: "https://img.invupos.com/clauweb/Empresas/Olive-garden.png", alt: "Olive Garden" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/Krispy_Kreme_logo.svg_sshr2p.png", alt: "Krispy Kreme" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/Subway.logo.8.5_e0sw4o%20%283%29.svg", alt: "Subway" },
      { src: "https://img.invupos.com/webinvu/Delivery/SOCIALTEL-LOGO-02.png", alt: "Selina" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/cropped-Website-Ajisen-37_vdskkr.webp", alt: "Ajisem Ramen" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/IHOP_logo.svg_nwncuz.png", alt: "Ihop" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/Cinnabon_logo.svg_unlk2s.png", alt: "Cinnabon" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/Little-Caesars-Logo_elzm7x.png", alt: "Little Caesars" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/Logo-maito-negro_vl6w8p.png", alt: "Maito" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/cantina-del-tigre_nb9rjo.png", alt: "Cantina del tigre" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/UNIDO_LOGO_01_1_riim8k.png", alt: "Unido" },
    ];
  
    // Duplicamos dentro de UNA sola pista para loop perfecto sin “salto”
    const track = [...logos, ...logos];
  
    return (
      <div
        className="relative w-full overflow-hidden py-10 group"
        // máscara sutil para entradas/salidas suaves
        style={{
          WebkitMaskImage:
            "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
          maskImage:
            "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
        }}
      >
        <style>{`
          @keyframes marqueeX {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .marquee-track {
            display: flex;
            align-items: center;
            width: max-content;
            animation: marqueeX var(--marquee-duration, 48s) linear infinite;
            will-change: transform;
          }
          .marquee-track > * + * { margin-left: ${gapRem}rem; } /* separación entre “cajas” */
          .paused { animation-play-state: paused; }
  
          /* Respeta reduce motion */
          @media (prefers-reduced-motion: reduce) {
            .marquee-track { animation: none !important; transform: none !important; }
          }
  
          /* Ajuste leve por viewport para elegancia */
          @media (min-width: 1024px) {
            .marquee-root { --marquee-duration: ${speed + 6}s; }
          }
          @media (max-width: 480px) {
            .marquee-root { --marquee-duration: ${Math.max(30, speed - 6)}s; }
          }
        `}</style>
  
        <div className="marquee-root">
          <div className={`marquee-track group-hover:paused`}>
            {track.map((logo, i) => {
              // detectar nombre de archivo para ajuste fino opcional
              const filename = logo.src.split("/").pop() || "";
              const tweak = Object.keys(brandAdjust).find(key =>
                filename.includes(key)
              );
              const scaleClass = tweak ? brandAdjust[tweak] : "";
  
              return (
                <div
                  key={i}
                  className="flex-shrink-0 flex items-center justify-center 
                             h-[68px] sm:h-[76px] lg:h-[86px]
                             w-[clamp(140px,12vw,240px)]" // caja uniforme
                >
                  <img
                    src={logo.src}
                    alt={logo.alt || ""}
                    loading="lazy"
                    className={`max-h-full max-w-full object-contain ${scaleClass}`}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

const Ferias = () => {
  return (
    <>
      <section className="w-full py-12 sm:py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          {/* Card container mimicking the rounded canvas */}
          <div className="rounded-[28px] border border-neutral-200 bg-white/90 shadow-sm ring-1 ring-black/5 flex flex-col">
            {/* Top area */}
            <div className="mx-auto max-w-4xl px-6 text-center pt-14 pb-8 sm:pt-20">
              <h1 className="text-4xl font-extrabold leading-tight tracking-tight text-neutral-900 sm:text-5xl md:text-6xl">
                Gestiona, vende y crece con
                <br className="hidden sm:block" />
                <span className="bg-gradient-clip11 text-[44px] sm:text-[64px] md:text-[76px] leading-none block mt-2">
                  INVU POS
                </span>
              </h1>

              {/* CTAs */}
              <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
                <a
                href="#demo"
                className="inline-flex items-center justify-center rounded-full bg-blue-600 px-6 py-3 text-base font-semibold text-white shadow-xl hover:bg-blue-700 hover:shadow-2xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600/60 transition-all duration-300"
                >
                Prueba el demo
                </a>

                <a
                href="#empezar"
                className="inline-flex items-center justify-center rounded-full bg-neutral-100 px-6 py-3 text-base font-semibold text-neutral-900 shadow-xl hover:bg-neutral-200 hover:shadow-2xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-400/60 transition-all duration-300"
                >
                Empieza Hoy
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="ml-1 h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 5l7 7-7 7"
                    />
                </svg>
                </a>
              </div>

              {/* Trust row */}
              <div className="mt-6 flex items-center justify-center gap-2 text-sm text-neutral-700">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 text-red-500"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
                <span className="tracking-wide font-semibold">TRUST</span>
                <span className="flex items-center gap-1 text-red-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <svg
                      key={i}
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </span>
                <span className="text-neutral-600">3800+ 5 Stars</span>
              </div>
            </div>

            {/* Device mockup with screenshot (pegada abajo) */}
            <div className="mt-auto">
              <div className="relative mx-auto max-w-5xl w-full">
                <div className="rounded-b-[24px] bg-white overflow-hidden">
                  <img
                    src="https://img.invupos.com/webinvu/Ferias/Group_1171275504_nsxnag%20%281%29.png"
                    alt="INVU POS UI"
                    className="block h-auto w-full"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="px-4 py-12 mt-4 mx-auto max-w-screen-xl">
          <LogoMarquee speed={42} gapRem={2} />
        </div>
      </section>

      <section className="w-full bg-white py-20 sm:py-28">
        <div className="mx-auto max-w-7xl px-6 sm:px-8 grid lg:grid-cols-2 gap-16 items-center">
          {/* Left image */}
          <div className="flex justify-center">
            <img
              src="https://img.invupos.com/webinvu/Ferias/Group_1171275306_dwmptt.png"
              alt="INVU POS Devices"
              className="max-w-full h-auto"
              loading="lazy"
            />
          </div>

          {/* Right text content */}
          <div className="space-y-8">
            <span className="inline-block rounded-full bg-blue-600/10 px-5 py-1.5 text-sm font-semibold text-blue-600">
              POS
            </span>

            <h2 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-neutral-900 leading-tight">
              Somos el <span className="text-blue-600">Match</span> perfecto
              para tu negocio
            </h2>

            <p className="text-lg sm:text-xl text-neutral-600 max-w-xl leading-relaxed">
              Con su solución basada en la nube, Invu POS te ofrece gestión de
              inventarios, clientes, facturación, proveedores, integraciones y
              mucho más. Empieza ahora y lleva tu negocio al siguiente nivel.
            </p>

            {/* OS Icons row */}
            <div className="flex items-center gap-6">
              <img
                src="https://img.invupos.com/webinvu/Ferias/Apple_bbrcva.svg"
                alt="Apple App Store"
                className="h-8 sm:h-10 md:h-10 w-auto object-contain"
                loading="lazy"
              />
              <img
                src="https://img.invupos.com/webinvu/Ferias/Android_jcpkj3.svg"
                alt="Google Play"
                className="h-8 sm:h-10 md:h-10 w-auto object-contain"
                loading="lazy"
              />
              <img
                src="https://img.invupos.com/webinvu/Ferias/windows_hcdejw.svg"
                alt="Microsoft Store"
                className="h-8 sm:h-10 md:h-10 w-auto object-contain"
                loading="lazy"
              />
            </div>
            <div>
              <a
                className="inline-flex items-center justify-center rounded-full bg-blue-600 px-8 py-4 text-lg font-semibold text-white shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600/60"
              >
                Disponible en todos los sistemas operativos
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full bg-white py-20 sm:py-20">
        <div className="mx-auto max-w-7xl px-6 sm:px-8">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
            {/* Left heading */}
            <div>
              <h2 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-neutral-900 leading-tight">
                Vende Más, Controla Todo,
                <br className="hidden sm:block" />
                Crece Sin Límites
              </h2>
            </div>

            {/* Right heading */}
            <div>
              <h3 className="text-2xl sm:text-3xl font-semibold text-neutral-800 leading-snug">
                Somos un software todo en uno
              </h3>
            </div>
          </div>

          {/* Stats */}
          <div className="mt-16 grid gap-12 md:grid-cols-3">
            {/* Stat 1 */}
            <div className="relative space-y-4">
              <div className="inline-flex items-center gap-2 rounded-md bg-rose-50 px-4 py-1.5 text-sm font-semibold text-rose-600">
                <span className="inline-block h-2.5 w-2.5 rounded-full bg-rose-500" />
                Incorporación simplificada
              </div>
              <div className="text-6xl font-extrabold text-neutral-900">
                100%
              </div>
              <p className="text-base text-neutral-600 max-w-xs leading-relaxed">
                Capacitación más rápida con un sistema intuitivo y fácil de
                usar.
              </p>
              <div className="pointer-events-none absolute right-[-20px] top-4 bottom-4 hidden md:block w-px bg-neutral-300" />
            </div>

            {/* Stat 2 */}
            <div className="relative space-y-4">
              <div className="inline-flex items-center gap-2 rounded-md bg-red-50 px-4 py-1.5 text-sm font-semibold text-red-600">
                <span className="inline-block h-2.5 w-2.5 rounded-full bg-red-500" />
                Inventario simplificado
              </div>
              <div className="text-6xl font-extrabold text-neutral-900">
                90%
              </div>
              <p className="text-base text-neutral-600 max-w-xs leading-relaxed">
                Con Invu POS simplificas tus inventarios y mantienes tu cierre
                al día en tiempo real.
              </p>
              <div className="pointer-events-none absolute right-[-20px] top-4 bottom-4 hidden md:block w-px bg-neutral-300" />
            </div>

            {/* Stat 3 */}
            <div className="space-y-4">
              <div className="inline-flex items-center gap-2 rounded-md bg-red-50 px-4 py-1.5 text-sm font-semibold text-red-600">
                <span className="inline-block h-2.5 w-2.5 rounded-full bg-red-500" />
                Administración unificada de tu equipo
              </div>
              <div className="text-6xl font-extrabold text-neutral-900">
                100%
              </div>
              <p className="text-base text-neutral-600 max-w-xs leading-relaxed">
                Nuestro sistema se integra a la perfección con KDS, delivery y
                kioskos.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full">
        <div className="mx-auto max-w-7xl px-6 sm:px-8">
          {/* Card principal */}
          <div className="rounded-[28px] bg-[#F4F4F4] shadow-xl ring-1 ring-black/5 p-6 sm:p-8 md:p-10">
            {/* Píldora */}
            <span className="inline-block rounded-full bg-blue-100 text-blue-700 text-sm font-semibold px-4 py-1">
              Delivery
            </span>

            {/* Grid 2 columnas */}
            <div className="mt-6 grid gap-10 md:grid-cols-[1.25fr_1fr] md:items-start">
              {/* Columna izquierda: título + copy + logos */}
              <div>
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold leading-tight text-neutral-900">
                  Sistema integrado para mayor{" "}
                  <span className="text-blue-600">eficiencia</span>
                </h2>

                <p className="mt-4 max-w-xl text-neutral-600 text-base sm:text-lg leading-relaxed">
                  Automatiza todo tu sistema de delivery, desde la toma de
                  pedidos hasta la entrega, integrando plataformas y controlando
                  cada orden en tiempo real.
                </p>

                {/* Logos partners */}
                <div className="mt-8 grid grid-cols-5 xs:grid-cols-3 sm:grid-cols-5 gap-4">
                  <div className="flex items-center justify-center aspect-[1/1]">
                    <img
                      src="https://img.invupos.com/webinvu/Ferias/didi_logo_e9esgo.png"
                      alt="DiDiFood"
                      className=""
                    />
                  </div>
                  <div className="flex items-center justify-center aspect-[1/1]">
                    <img
                      src="https://img.invupos.com/webinvu/Ferias/rappi_ptbmdg.png"
                      alt="Rappi"
                      className=""
                    />
                  </div>
                  <div className="flex items-center justify-center aspect-[1/1]">
                    <img
                      src="https://img.invupos.com/webinvu/Ferias/deliverect_rvk5lq.png"
                      alt="Deliverect"
                      className=""
                    />
                  </div>
                  <div className="flex items-center justify-center aspect-[1/1]">
                    <img
                      src="https://img.invupos.com/webinvu/Ferias/Pedidos_ya_xq73vm.png"
                      alt="PedidosYa"
                      className=""
                    />
                  </div>
                  <div className="flex items-center justify-center aspect-[1/1]">
                    <img
                      src="https://img.invupos.com/webinvu/Ferias/Uber_eats_fc0rbc.png"
                      alt="UberEats"
                      className=""
                    />
                  </div>
                </div>
              </div>

              {/* Columna derecha: imagen + tarjeta flotante */}
              <div className="relative">
                {/* Contenedor con aspecto fijo para evitar saltos */}
                <div className="relative aspect-[16/10] w-full overflow-hidden rounded-2xl shadow-md bg-gradient-to-br from-neutral-200 to-neutral-300">
                  {/* Placeholder visible (se reemplaza por tu imagen) */}
                  <img
                    src="https://img.invupos.com/webinvu/Ferias/pexels-francisco-ferreira-141445304-13311393_2_isctrp.png"
                    alt="Delivery Moto"
                    className="absolute inset-0 h-full w-full object-cover"
                  />

                  {/* Tarjeta flotante anclada dentro del mismo contenedor */}
                  <div className="absolute bottom-4 right-4 sm:bottom-6 sm:right-6 bg-white/95 backdrop-blur rounded-2xl shadow-lg ring-1 ring-black/5 p-4 sm:p-5 w-[220px]">
                    <span className="block text-[11px] font-semibold text-rose-600 bg-rose-100 rounded-md px-2 py-1 mb-2">
                      Agiliza tus operaciones
                    </span>
                    <div className="text-4xl font-extrabold text-neutral-900">
                      100%
                    </div>
                    <p className="mt-1 text-xs text-neutral-600 leading-relaxed">
                      Agilizamos la gestión de tus deliverys con nuestras
                      integraciones
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Badges */}
          <div className="mt-8 flex justify-center">
            <div className="rounded-2xl bg-white shadow-xl ring-1 ring-black/5 w-full max-w-4xl px-6 sm:px-8 py-3 sm:py-4 flex flex-wrap items-center justify-center gap-4 sm:gap-6">
              <img
                src="https://img.invupos.com/webinvu/Ferias/Capterra-shortlist-2025_oux8jq.png"
                alt="Capterra Shortlist 2025"
                className="h-20 md:h-[100px] w-auto object-contain"
                loading="lazy"
              />
              <img
                src="https://img.invupos.com/webinvu/Ferias/Software-advice-front-runners_1_vwaje1.png"
                alt="Software Advice Front Runners"
                className="h-20 md:h-[100px] w-auto object-contain"
                loading="lazy"
              />
              <img
                src="https://img.invupos.com/webinvu/Ferias/Get-app-category-leaders-2025_fvxsq1.png"
                alt="GetApp Category Leaders 2025"
                className="h-20 md:h-[100px] w-auto object-contain"
                loading="lazy"
              />
              <img
                src="https://img.invupos.com/webinvu/Ferias/BESTEASEOFUSE2024_e43of6.png"
                alt="Best Ease of Use 2024"
                className="h-20 md:h-[100px] w-auto object-contain"
                loading="lazy"
              />
              <img
                src="https://img.invupos.com/webinvu/Ferias/CUSTOMERSUPPORT2024_zets2b.png"
                alt="Customer Support 2024"
                className="h-20 md:h-[100px] w-auto object-contain"
                loading="lazy"
              />
              <img
                src="https://img.invupos.com/webinvu/Ferias/ga-features_and_functionality-2023_mlr5e9.png"
                alt="GetApp Features & Functionality 2023"
                className="h-20 md:h-[100px] w-auto object-contain"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="w-full bg-white py-16 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid items-center gap-10 lg:grid-cols-2">
            {/* Imagen izquierda con difuminado abajo */}
            <div className="relative flex justify-center lg:justify-start">
              <div className="relative w-[520px] md:w-[640px] lg:w-[720px] lg:-ml-8">
                <img
                  src="https://img.invupos.com/webinvu/Ferias/Group_1171275504_1_nkisit.png"
                  alt="Kioskos de autoservicio"
                  className="block w-full h-auto object-contain"
                  loading="lazy"
                />
                {/* Fader inferior: ajusta la altura si quieres más/menos difuminado */}
                <div className="pointer-events-none absolute inset-x-0 bottom-0 h-20 sm:h-24 bg-gradient-to-t from-white to-transparent" />
              </div>
            </div>

            {/* Texto derecha */}
            <div className="px-1 sm:px-2">
              <h2 className="text-[40px] sm:text-[52px] md:text-[64px] font-extrabold leading-[1.08] tracking-tight text-neutral-900">
                <span className="text-blue-600">Kioskos</span> que venden por
                ti, las 24 horas
              </h2>

              <p className="mt-6 max-w-2xl text-neutral-600 text-lg leading-relaxed">
                Optimiza tu negocio con kioskos de autoservicio que agilizan
                pedidos, reducen filas y aumentan tus ventas, todo conectado a
                tu sistema POS en tiempo real.
              </p>

              <div className="mt-8">
                <a
                  className="inline-flex items-center justify-center rounded-full bg-blue-600 px-10 py-4 text-lg font-semibold text-white shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600/60"
                >
                  Cotiza ahora
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full py-16 sm:py-32 mt-12">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          {/* Card blanca */}
          <div className="relative overflow-visible rounded-[32px] bg-white shadow-xl ring-1 ring-black/5">
            <div className="grid gap-6 md:gap-10 md:grid-cols-2">
              {/* Columna izquierda: texto */}
              <div className="px-6 sm:px-10 md:px-12 py-10 md:py-14">
                <h2 className="text-[32px] sm:text-[44px] md:text-[52px] font-extrabold leading-[1.08] tracking-tight text-neutral-900">
                  Convierte <span className="text-blue-600">clientes</span>
                  <br className="hidden sm:block" /> en fans de tu marca
                </h2>

                <p className="mt-6 max-w-2xl text-neutral-700 text-lg leading-relaxed">
                  Potencia la fidelización de tus clientes con punch cards,
                  wallet digital, newsletters y muchas más herramientas
                  integradas en tu POS.
                </p>

                <div className="mt-8">
                  <a
                    className="inline-flex items-center justify-center rounded-full bg-blue-600 px-8 sm:px-10 py-3.5 sm:py-4 text-base sm:text-lg font-semibold text-white shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600/60"
                  >
                    Fideliza ahora
                  </a>
                </div>
              </div>

              {/* Columna derecha: mockups + bloque claro de fondo */}
              <div className="relative min-h-[280px] md:min-h-[420px]">
                {/* bloque claro redondeado detrás */}

                {/* imagen de mockups que sobresale por abajo */}
                <img
                  src="https://img.invupos.com/webinvu/Ferias/invu_mockups_multiple_screens_1_krnysm.png"
                  alt="Mockups móviles de fidelización"
                  className="absolute right-0 md:right-2 bottom-[-56px] md:bottom-[-72px] w-[420px] md:w-[520px] lg:w-[620px] max-w-none drop-shadow-2xl"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Ferias;
